<template>
  <div>
    <div 
      v-if="parkingLot!=null" 
      style="display: flex; flex-direction: column; height: 100%;">
      <div
        v-if="!completed && !alreadyRequested"
        style="overflow-y: scroll;"
        class="px-3"
      >
        <div class="m-0 mt-4">
          <i
            class="fa-solid fa-angle-left px-3 py-2 text-center bg-white"
            style="color:#011638; border-radius: 12px;font-size: 1.3rem; "
            @click="$router.go(-1);"
          />
          <span
            style="color:#011638; font-weight: 600; font-size: 1.1rem;"
            class="ms-3"
          >Solicitud de visita</span>
        </div>
        <p
          class="mt-3 ps-3 mb-0"
          style="color: #56647A; font-size: .9rem;"
        >
          Tus datos 
          <i 
            style="font-size: 1rem;color:#15E0DD;"
            class="fa-solid fa-pen-to-square ms-2"
            @click="open_drawer()"></i>
        </p>
        <div class="row m-0 my-3">
          <div class="col-3 m-0">
            <img
              src="../../src/assets/user_image.png"
              style="border-radius: 100; width: 100%;height: auto;"
            >
            <p
              style="font-size: 0.8rem;color:#242f4a;" 
              class="text-center mt-1 fw-bold"
              v-if="me">{{ me.name.split(' ').slice(0, 2).join(' ') }}</p>
          </div>
          <div 
            class="col-9 m-0 p-3 rounded-4"
            style="background-color: #242f4a; cursor:pointer"
            @click="open_drawer()">
            <p
              class="my-1 truncated-text"
              style="color:white;"
            >
              <i
                style="width: 15px;" 
                class="fa-solid fa-location-dot me-2 text-center" />
              <span 
                class="ps-1"
                v-if="input.address.street">
                {{ input.address ? input.address.street : "" }}, {{ input.address ? input.address.city : "" }}
              </span>
              <span>
                Pendiente definir
              </span>
            </p>
            <p
              class="my-1"
              style="color:white"
            >
              <span v-if="input.time && (input.time.startTime || input.weekend_full_day)">
                <i 
                  style="width: 15px;"   
                  class="fa-regular fa-clock me-2" />
                <span
                  v-if="input.time.startTime"
                  class="ps-1"
                >
                  L-V
                  <span v-if="input.time.startTime == '00:00' && input.time.endTime == '00:00'">
                    24h
                  </span>
                  <span v-else>{{ input.time.startTime }}h - {{ input.time.endTime }}h</span>
                </span>
                <span 
                  class="ps-1"
                  v-if="input.weekend_full_day">S-D 24h</span>
              </span>
              <span v-else>
                <i 
                  style="width: 15px;"   
                  class="fa-regular fa-clock me-2" />
                <span>
                  Pendiente definir
                </span>
              </span>
            </p>
            <p
              class="my-1"
              style="color:white"
            >
              <i 
                style="width: 15px;" 
                class="fa-solid fa-car me-2 " />
              <span 
                v-if="input.vehicle_size">
                Coche {{ formattedSize }} <span v-if="input.vehicle_model">({{ input.vehicle_model}})</span>
              </span>
              <span v-else>
                Pendiente definir
              </span>
            </p>
            <p
              class="my-1"
              style="color:white">
              <i 
                style="width: 15px;" 
                class="fa-regular fa-calendar me-2 " />
              <span 
                class="ps-1"
                v-if="input.duration">{{ formattedPeriod }}</span>
              <span
                class="ps-1"  
                v-else>Pendiente definir</span>
            </p>
          </div>
        </div>
        <p
          class="mt-4 ps-3 mb-0"
          style="color: #56647A; font-size: .9rem;"
        >
          Mensaje para <span class="text-capitalize">{{ parkingLot.user.name?.toLowerCase() }}</span>
        </p>
        <div
          class="bg-white rounded-4 p-1 my-3"
          style="color:#011638"
        >
          <textarea
            v-model="message"
            class="form-control border-0 py-2 px-3"
            style="height: 90px; font-size: 1rem; color: #011638;"
          />
        </div>
        <span
          v-if="form_error"
          class="text-danger px-3"
        >
          Debes rellenar todos los campos (*)
        </span>
        <button
          class="btn py-2 w-100 rounded-3 my-3"
          style="background-color: #15E0DD; font-size: 1.1rem;font-weight: 600; color: #011638"
          @click="submit()"
        >
          <span>Enviar solicitud</span>
        </button>
      </div>
      <div
        v-if="completed"
        style="height: calc(100% - 50px);"
        class="d-flex align-items-center"
      >
        <div class="w-100">
          <div class="w-100 d-flex mb-5 justify-content-center">
            <img
              src="@/assets/checked-register.png"
              alt="Email enviada"
              class="img-fluid"
            >
          </div>
          <h3
            class="text-center mb-3 fw-bold mx-3"
            style="color:#394A64"
          >
            ¡Enhorabuena!
          </h3>
          <p
            style="color:#56647A"
            class="mx-3 text-center"
          >
            ¡Solicitud enviada a {{ parkingLot.user.name }}! Esperamos que se ponga en contacto contigo pronto para enseñarte el garaje
          </p>
        </div>
      </div>
      <div
        v-if="completed"
        style="height: 50px;"
        class="mt-3 mx-3 mb-3"
      >
        <button
          class="btn py-2 w-100 rounded-3"
          style="background-color: #15E0DD; font-size: 1.1rem;font-weight: 600; color: #011638"
          @click="close"
        >
          <span>Cerrar</span>
        </button>
      </div>
      <div
        v-if="alreadyRequested"
        style="height: calc(100% - 50px);"
        class="d-flex align-items-center"
      >
        <div class="w-100">
          <div class="w-100 d-flex mb-5 justify-content-center">
            <img
              src="@/assets/checked-register.png"
              alt="Email enviada"
              class="img-fluid"
            >
          </div>
          <h3
            class="text-center mb-3 fw-bold mx-3"
            style="color:#394A64"
          >
            ¡Ya has enviado una solicitud a este garaje!
          </h3>
          <p
            style="color:#56647A"
            class="mx-3 text-center"
          >
            Espera a que {{ parkingLot.user.name }} se ponga en contacto contigo
          </p>
        </div>
      </div>
      <div
        v-if="alreadyRequested"
        style="height: 50px;"
        class="mt-3 mx-3 mb-3"
      >
        <button
          class="btn py-2 w-100 rounded-3"
          style="background-color: #15E0DD; font-size: 1.1rem;font-weight: 600; color: #011638"
          @click="close"
        >
          <span>Cerrar</span>
        </button>
      </div>
      <drawer
        ref="drawer"
        :weekdays="weekdays"
        :input="input"
        :is_parker="false"
        :is_request="true"
        :individual_step="false"
        @get-data-input="handleGetInput"
      />
      <drawer-login
        ref="drawer_login"
        style="z-index: 1000 !important;"
        :is_driver="true"
        @login-completed="/*this.trackMixPanel('USUARIO LOGUEADO'),*/submit"
        @confirm-mail="this.trackMixPanelLogin('appconfirmmaildriver_click_confirmar', false)"
        @confirm-personal-data="this.trackMixPanelLogin('appconfirmmaildriver_click_confirmar', true)"
      />
    </div>
    <div
      v-else
      class="d-flex align-items-center "
      style="height: 100% !important;">
      <div class="pb-5">
        <div class="d-flex justify-content-center mb-5">
          <img 
            src="../assets/parker_notFound.png" 
            style="width: 80%; height: auto;"
            alt="">
        </div>
        <div>
          <h4 class="text-center px-5">
            Lo sentimos, esta plaza de garaje ya no está disponible. 
            <br>Pero no te preocupes, ¡tenemos más!
          </h4>
          <p 
            style="font-size: 1rem; color: #7a7a7a; margin-top: 0.5rem;"
            class="text-center mb-0">
            Solo dinos cuándo y dónde necesitas aparcar aquí:
          </p>
          <div class="d-flex justify-content-center">
            <router-link 
              to="/create-driver"
              style="background-color: #011638;"
              class="btn btn-dark mt-3">Solicitar garaje</router-link>
          </div>
        </div>
      </div>
    </div>
    <spinner-component
      id="spinner"
      class="d-none"
      style="z-index: 100;"></spinner-component>
  </div>
</template>
<script>
  //import router from '@/router';
  import { mapState } from 'vuex';
  import Drawer from '../components/Drawer.vue';
  import DrawerLogin from '../components/DrawerLogin.vue';
  import axios from "axios";
  import { formatPeriod, formatSize } from '../services/traslation';
  import mixpanel from 'mixpanel-browser';
  import SpinnerComponent from '../components/SpinnerComponent.vue'
  import { useRoute } from 'vue-router'

  export default {
    name: 'FichaGaraje',
    components:{
      Drawer,
      DrawerLogin,
      SpinnerComponent
    },
    data: function() {
      return {
        map: {},
        parking_lot_id: null,
        alreadyRequested: false,
        input: {
          vehicle_model: "",
          vehicle_size: null,
          duration: null,
          location: null,
          time: {},
          address: {
            address: "",
            city: ""
          }
        },
        parkingLot: {
          "user": "",
          "address": "",
          weekend_full_day: false,
        },
        weekdays: false,
        completed: false,
        form_error: false,
        message: "",
        me: null,
        route: useRoute(),
      }
    },
    computed: {
      ...mapState(['input']),
      ...mapState(['isLoggedIn']),
      ...mapState(['token']),
      formattedSize() {
        return formatSize(this.input.vehicle_size);
      },
      formattedPeriod(){
        return formatPeriod(this.input.duration)
      }
    },
    mounted(){
      const apiUrl = process.env.VUE_APP_API_URL+'/api/token/verify';
      const token={
        "token": this.token
      }
      axios.post(apiUrl, token)
      .then(response => {
        console.log(response)
      })
      .catch(error => {
        console.log(error)
        this.$store.commit('logout');
        this.$router.push("/alquiler-garaje/"+id);
      }); 
      const id = this.$route.params.id; // Obtener el ID desde los parámetros de la ruta
      this.parking_lot_id = id;
      this.fetchParkingLot(id)
      this.input.duration = ""
      this.getUserPreference()
    },
    methods: {
      trackMixPanel(mensaje){
        mixpanel.track(mensaje, {
          pantalla: 'Solicitar Garaje',
          garage_id: this.parkingLot.id,
        });
      },
      trackMixPanelLogin(mensaje, isNewUser){
        let userType = isNewUser ? 'newUser' : 'existing';
        mixpanel.track(mensaje, {
          pantalla: 'Solicitar Garaje',
          garage_id: this.parkingLot.id,
          userType: userType
        });
      },
      formatTime(minutes) {
          let hours = Math.floor(minutes / 60);
          let mins = minutes % 60;

          let hoursStr = hours.toString().padStart(2, '0');
          let minsStr = mins.toString().padStart(2, '0');

          return `${hoursStr}:${minsStr}`;
        },

      async checkIfParkingLotAlreadyRequested() {
        if (!this.isLoggedIn) {
          return
        }
        const url = process.env.VUE_APP_API_URL+`/api/me/requests?parking_lot_id=` + this.parkingLot.id
        const response = await fetch(url, {
          headers: {
              'Authorization': `Bearer ${this.token}`
              },
          });
        if (!response.ok) throw new Error('Error al obtener los datos del parking lot');
        const data = await response.json();


        if (data.length == 0){
          return
        }
        this.alreadyRequested = true
      },
      async getInfoMe() {
        if (!this.isLoggedIn) {
          return
        }
        const url = process.env.VUE_APP_API_URL+`/api/me`
        const response = await fetch(url, {
          headers: {
              'Authorization': `Bearer ${this.token}`
              },
          });
        if (!response.ok) throw new Error('Error al obtener los datos del parking lot');
        this.me = await response.json();
      },
      async getUserPreference() {
        if (!this.isLoggedIn) {
          return
        }
        try {
        const url = process.env.VUE_APP_API_URL+`/api/user_preferences/`
        const response = await fetch(url, {
          headers: {
              'Authorization': `Bearer ${this.token}`
              },
          });
        if (!response.ok) throw new Error('Error al obtener los datos del parking lot');
        const data = await response.json();


        if (data.length == 0){
          return
        }

        let user_prefence

        const driver_id = this.route.query.driver_id
        if (driver_id !== null && driver_id !== undefined && driver_id !== "") {
          const found = data.find(item => item.id == driver_id);
          user_prefence = found ?? data[0];
        } else {
          user_prefence = data[0];
        }
        

        this.input.address.center = [user_prefence.location.latitude, user_prefence.location.longitude]
        this.input.address.address = user_prefence.address.street
        this.input.address.street = user_prefence.address.street
        this.input.address.zip_code = user_prefence.address.zip_code
        this.input.address.state = user_prefence.address.state
        this.input.address.city = user_prefence.address.city
        this.input.vehicle_size = user_prefence.vehicle_size
        this.input.time.startTime = this.formatTime(user_prefence.start_hour)
        this.input.time.endTime = this.formatTime(user_prefence.end_hour)
        this.weekdays = user_prefence.start_hour ? true : false
        this.parkingLot.weekend_full_day = user_prefence.weekend_full_day
        this.input.vehicle_model = user_prefence.vehicle_model
        this.input.duration = user_prefence.period
        this.input = structuredClone(this.input)
        console.log(this.input, "INPUT")
      } catch (error) {
        console.error('Error fetching parking lot:', error);
      }

      },
      async fetchParkingLot(id) {
        try {
          const url = process.env.VUE_APP_API_URL+`/api/parking_lots/${id}`
          const response = await fetch(url);
          var spinner = document.getElementById("spinner")
          spinner.classList.remove("d-none")
          if (!response.ok) throw new Error('Error al obtener los datos del parking lot');
          const data = await response.json();
          this.parkingLot = data;

          spinner.classList.add("d-none")

          this.checkIfParkingLotAlreadyRequested();

          this.getInfoMe();

          this.message = `Hola, estoy interesado en alquilar tu garaje. ¿Cuándo podría visitarlo?`

        } catch (error) {
          console.error('Error fetching parking lot:', error);
          this.parkingLot = null
          spinner.classList.add("d-none")
        }
      },
      async submit(){
        this.trackMixPanel("garagerequest_click_enviar solicitud")
        if(!this.input.duration || !this.input.vehicle_size || !this.input.address || !this.input.vehicle_size || !this.input.time){
          //this.trackMixPanel("DATOS INVALIDOS")
          this.form_error = true
          return
        }

        this.form_error = false

        if(!this.isLoggedIn){
          //this.trackMixPanel("ABRIR DRAWER LOGIN")
          this.$refs.drawer_login.openDrawer()
          return
        }
        
        try{
          var spinner = document.getElementById("spinner")
          spinner.classList.remove("d-none")

          const apiUrl = process.env.VUE_APP_API_URL+'/api/token/verify';
          const token={
            "token": this.token
          }
          console.log("AQUI VOYYYY")
          await axios.post(apiUrl, token)
          .then(response => {
            console.log("Entro al response", response)
          })
          .catch(error => {
            console.log("ENTRO AL CATCH")
            spinner.classList.add("d-none")
            this.$store.commit('logout');
            this.$refs.drawer_login.openDrawer()
            console.log(error)
            return
          }); 

          let startMinutes = null
          let endMinutes = null

          if (this.input.time.startTime && this.input.time.endTime) {
            console.log("EENTRO")
            const [startHour, startMinute] = this.input.time.startTime.split(":").map(Number);
            startMinutes = startHour * 60 + startMinute;

            const [endHour, endMinute] = this.input.time.endTime.split(":").map(Number);
            endMinutes = endHour * 60 + endMinute;
          }


          console.log(this.input.address)

          const body = {
            location: {
              latitude: this.input.address.center[0],
              longitude: this.input.address.center[1]
            },
            address: {
              street: this.input.address.street,
              city: this.input.address.city,
              state: this.input.address.state,
              zip_code: this.input.address.zip_code,
            },
            vehicle_size: this.input.vehicle_size,
            vehicle_model: this.input.vehicle_model,
            weekend_full_day: this.parkingLot.weekend_full_day,
            start_hour: startMinutes,
            end_hour: endMinutes,
            period: this.input.duration,
            comments: this.message,
          }

          await axios.post(process.env.VUE_APP_API_URL + '/api/parking_lots/' + this.parking_lot_id + '/requests',
            body,{
            headers: {
              'Authorization': `Bearer ${this.token}`
              },}
          )
          spinner.classList.add("d-none")
          this.completed = true
        
        }catch(error){
          console.log(error)
          spinner.classList.add("d-none")
          this.$store.commit('logout');
          this.submit()
        }
        //this.trackMixPanel("GARAJE SOLICITADO")
      },
      open_drawer(){
        this.$refs.drawer.openDrawer()
        //this.$refs.drawer.change_step(step)
      },
      handleGetInput(input){
        this.input.address = input.address
        this.input.time = input.time
        this.input.weekend_full_day = input.weekend_full_day
        this.input.vehicle_size = input.vehicle_size
        this.input.vehicle_model = input.vehicle_model
        this.input.duration = input.duration
      },
      close() {
        window.open("https://parkiduo.com", "_blank");
      },
    }
  }
</script>
<style scoped>
  .truncated-text {
    white-space: nowrap;        /* Evita saltos de línea */
    overflow: hidden;           /* Oculta el texto que se pase */
    text-overflow: ellipsis;    /* Agrega "..." al final si es muy largo */
    max-width: 100%;            /* Asegura que no crezca más allá del col-6 */
    display: block;             /* Asegura que respete los estilos de ancho */
  }

  .form-check-input:checked {
      background-color: #15E0DD;
      border-color: #15E0DD;
  }
</style>
